import * as time from './time'          // 时间类型过滤器
import * as constant from './constant'  // 常数类型过滤器
import * as common from './common'      // 公共类型过滤器

const vFilter = {
  ...time,
  ...constant,
  ...common,
  install: (Vue) => {
    for (let key in vFilter) {
      Vue.filter(key, vFilter[key])
    }
  }
}

export default vFilter



// WEBPACK FOOTER //
// ./src/filters/index.js